export default __webpack_public_path__ + "static/media/les_andelys02.5c8b77a8.jpg";